<div class="main-page">

  <app-header></app-header>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    <div class="advertisement">
      <div class="innerPage advertisement-inner">
        <div class="ads-header">
          <div>
            <div class="ads-title">
              <span class="ads-title-icon" aria-hidden="true"><i class="fa-solid fa-bullhorn"></i></span>
              My Advertisements
            </div>
            <div class="ads-subtitle">
              Manage your ads and track your schedules
              <span class="ads-badge">Coming Soon</span>
            </div>
          </div>
          <button class="ads-create" type="button" (click)="createAds(content)">
            <i class="fa-solid fa-plus" aria-hidden="true"></i>
            Create Ad
          </button>
        </div>

        <div class="ads-empty" *ngIf="!advertisements?.length; else adsTable">
          <div class="ads-empty__icon"><i class="fa-regular fa-rectangle-list"></i></div>
          <div class="ads-empty__title">No advertisements yet</div>
          <div class="ads-empty__subtitle">Click “Create Ad” to add your first advertisement.</div>
        </div>

        <ng-template #adsTable>
          <div class="ads-table-wrap">
            <table class="table ads-table">
              <thead>
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Image</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                  <th scope="col" class="ads-actions-col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let advertisement of advertisements">
                  <td class="ads-td-title">
                    <div class="ads-td-title__text">{{ advertisement.title || '-' }}</div>
                  </td>
                  <td class="ads-td-img">
                    <img
                      class="ads-thumb"
                      [src]="(advertisement.imagePath | userProfilePhoto:'assets/imageplaceholder.jpeg')"
                      (error)="onImgError($event, 'assets/imageplaceholder.jpeg')"
                      alt="Ad image"
                    />
                  </td>
                  <td class="ads-td-date">
                    <i class="fa-regular fa-calendar"></i>
                    {{ advertisement.startDate | date:"MMM dd, yyyy" }}
                  </td>
                  <td class="ads-td-date">
                    <i class="fa-regular fa-calendar"></i>
                    {{ advertisement.endDate | date:"MMM dd, yyyy" }}
                  </td>
                  <td class="ads-td-actions">
                    <button type="button" class="ads-icon-btn" (click)="delete(advertisement._id)" aria-label="Delete">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
          

      </div>
    </div>
  </div>






</div>



<ng-template #content let-modal>

  <button type="button" class="btnn btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">X</button>

  <div class="modal-body modal-body1">
    <form>
      <div class="mb-3 d-flex flex-wrap text-center justify-content-center">
        <!-- <img class="logoo" src="../../assets/logo-5.png" /> -->
        <h3 class="w-100 ">Subscription Required</h3>
        <h6 class="w-100">Would you like to upgrade your business?</h6>
        <p class="w-100 mt-2">
          <button (click)="goToSubscribe()" class=" btn-primary">Review Plans</button>
          <button  (click)="goToDashboard()"
            style="margin-left: 10px ;" class=" btn-danger">Cancel</button></p>
      </div>
    </form>
  </div>
</ng-template>